import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JsonTreeModule } from '../json-tree/index';
import { LogMonitorComponent } from './log-monitor';
import { LogMonitorButtonComponent } from './log-monitor-button';
import { LogMonitorEntryComponent } from './log-monitor-entry';
export var LogMonitorModule = (function () {
    function LogMonitorModule() {
    }
    LogMonitorModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        JsonTreeModule
                    ],
                    declarations: [
                        LogMonitorComponent,
                        LogMonitorButtonComponent,
                        LogMonitorEntryComponent
                    ],
                    exports: [
                        LogMonitorComponent
                    ]
                },] },
    ];
    /** @nocollapse */
    LogMonitorModule.ctorParameters = [];
    return LogMonitorModule;
}());
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngrx/store-log-monitor/src/log-monitor/index.js
// module id = JUgO
// module chunks = 4